import DOMPurify from 'dompurify'

export const sanitizeValue = (value) => {
  return DOMPurify.sanitize(value, { USE_PROFILES: { html: false } })
}
